import { CodeResponse, useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';

import { getBaseRequestConfig } from '../../utils/requestConfig';

type AuthCodeResponse = Omit<CodeResponse, 'error' | 'error_description' | 'error_uri'>;

const generateUrlRedirect = (location: Location) =>
  location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');

export const useGoogleAuthLogin = (
  onFailure: (error: unknown) => void,
  onUserLoggedIn: (response?: unknown) => void,
  onLoadingChange?: (isLoading: boolean) => void
) => {
  const login = async (googleAuthorizationCode: AuthCodeResponse) => {
    const requestUrl = `/api/auth/google/login?redirect_url=${generateUrlRedirect(window.location)}`;
    onLoadingChange?.(true);

    try {
      const response = await axios.post(
        requestUrl,
        googleAuthorizationCode,
        getBaseRequestConfig()
      );

      onUserLoggedIn(response);
    } catch (error) {
      onLoadingChange?.(false);
      onFailure(error);
    }
  };

  return useGoogleLogin({
    flow: 'auth-code',
    onSuccess: login,
    onError: (error) => {
      onLoadingChange?.(false);
      onFailure(error);
    },
  });
};